import { getHeightOfHidden } from '../helpers/getHeightOfHidden';

interface MenuSection {
    trigger: HTMLButtonElement;
    panel: HTMLElement;
    anchorLinks: any;
}

class DropDownAnchorsNavigation {
    container: HTMLElement;
    menuSections: Array<MenuSection>;
    constructor(dropdownNavContainer) {
        this.menuSections = [];
        this.container = dropdownNavContainer;
    }

    init() {
        const dropDown = this.container
        const triggerBtn = dropDown.querySelector('[data-panels-trigger]') as HTMLButtonElement;
        const anchorLinksArray = dropDown.querySelectorAll('[data-dropdown-anchor-link]') as any;

        if (triggerBtn) {
            this.menuSections.push({
                trigger: triggerBtn,
                panel: triggerBtn.nextElementSibling as HTMLElement,
                anchorLinks: anchorLinksArray
            });
        }

        this.menuSections.forEach(section => {

            const panelDiv = section.panel;
            section.trigger.addEventListener('click', () => {
                this.togglePanel(section);

                const panelHeight = getHeightOfHidden(panelDiv);
                panelDiv.style.height = `${panelHeight}px`;

            });

            section.anchorLinks.forEach(anchorLink => {
                anchorLink.addEventListener('click', (e: Event) => {
                    e.preventDefault();

                    this.closeAllPanels();

                    setTimeout(() => {
                    const duration = 1000;
                    const targetId = anchorLink.getAttribute("data-dropdown-anchor-link");
                    const element = document.getElementById(targetId);
                    const stickyOffset = document.querySelector('.timeline-page-main-header') ? 100 : 0;
                    const offset = 40 + stickyOffset;
                    const elementRect = element.getBoundingClientRect().top;
                    const startingY = window.pageYOffset;
                    const elementY = window.pageYOffset + elementRect;

                    // If element is close to page's bottom then window will scroll only to some position above the element.
                    var targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY
                    var diff = targetY - startingY - offset
                    // Easing function: easeInOutCubic
                    // From: https://gist.github.com/gre/1650294
                    var easing = function (t) { return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1 }
                    var start;

                    if (!diff) return

                    // Bootstrap our animation - it will get called right before next frame will be rendered.
                    window.requestAnimationFrame(function step(timestamp) {
                        if (!start) start = timestamp;
                        // Elapsed miliseconds since start of scrolling.
                        var time = timestamp - start;
                        // Get percent of completion in range [0, 1].
                        var percent = Math.min(time / duration, 1);
                        // Apply the easing.
                        percent = easing(percent);

                        window.scrollTo(0, startingY + diff * percent);

                        // Proceed with animation as long as we wanted it to.
                        if (time < duration) {
                            window.requestAnimationFrame(step);
                        }
                    });

                    const panelHeader = element.querySelector('.timeline-container-block-title') as HTMLElement;
                    panelHeader.setAttribute('tabindex', '-1');
                    panelHeader.focus();

                    }, 400); // wait till .2 sec height transition has completed.
                })
            });


        });

        document.body.addEventListener('click', (e: Event) => {
            const clickedOutsideOfNav = !this.container.contains(e.target as Element);
            if (clickedOutsideOfNav) {
                this.closeAllPanels();
            }
        });

        document.body.addEventListener('click', (e: Event) => {
            const clickedOutsideOfNav = !this.container.contains(e.target as Element);
            if (clickedOutsideOfNav) {
                this.closeAllPanels();
            }
        });

        document.body.addEventListener('keyup', (e: KeyboardEvent) => {
            if (e.which == 27) {
                this.closeAllPanels();
            }
        });
    }



    togglePanel(section: MenuSection) {
        if (section.trigger && section.panel) {
            if (section.trigger.getAttribute('aria-expanded') == 'true') {
                this.closePanel(section);
            }
            else {
                this.openPanel(section);
            }
        }
    }

    openPanel(section: MenuSection) {
        this.menuSections.forEach(sectionInList => {
            if (section.trigger != sectionInList.trigger) {
                this.closePanel(sectionInList);
            }
        })
        section.trigger.setAttribute('aria-expanded', 'true');
        section.panel.setAttribute('aria-hidden', 'false');
    }

    closePanel(section: MenuSection) {
        section.trigger.setAttribute('aria-expanded', 'false');
        section.panel.setAttribute('aria-hidden', 'true');
    }

    closeAllPanels() {
        this.menuSections.forEach(sectionInList => {
            this.closePanel(sectionInList);
        });
    }
}

let DropDownAnchorsNav: DropDownAnchorsNavigation;
const dropdownNavContainer = document.querySelector('#Drop_Down_Anchors_Nav') as HTMLElement;
if (dropdownNavContainer) {
    DropDownAnchorsNav = new DropDownAnchorsNavigation(dropdownNavContainer);
}

export { DropDownAnchorsNav };